import { RoutesInterface } from '@navigation/authRoutes';
import MyProfileScreen from '@screens/MyProfile/MyProfileScreen';
import POSScreen from '@screens/POS/POSScreen';
import ListOrdersScreen from '@screens/Orders/ListOrders';
import ComputerIcon from '@mui/icons-material/Computer';
import DescriptionIcon from '@mui/icons-material/Description';
import PeopleIcon from '@mui/icons-material/People';
import CircleIcon from '@mui/icons-material/Circle';
import QueryStatsIcon from '@mui/icons-material/QueryStats';
import ListBranchOfficeInventoryScreen from '@screens/BranchOffices/Inventory/InventoryScreen';
import InventoryPOS from '@screens/BranchOffices/Inventory/InventoryPOS';
import SalesReportScreen from '@screens/SalesReport/CollaboratorSalesReportScreen';
import ListCustomersScreen from '@screens/Customers/ListCustomersScreen';
import { DinnerDining } from '@mui/icons-material';
import ListTablesKiosksScreen from '@screens/TableKiosks/ListTablesKiosksScreen';

const collaboratorRoutes: RoutesInterface[] = [
    {
        path: 'myProfile',
        name: 'Mi Perfil',
        element: MyProfileScreen
    },
    {
        // Cutover F6 (2026-08-17): el POS de manager/colaborador ES el POS 2.0
        // (vende desde `dishes`, líneas v2). El POS v1 se ELIMINÓ del código —
        // una orden v1 viva se resuelve desde la lista de pedidos, no en el POS.
        path: 'home',
        name: 'Punto de venta',
        element: POSScreen,
        icon: ComputerIcon
    },
    {
        path: 'orders',
        name: 'Pedidos',
        element: ListOrdersScreen,
        icon: DescriptionIcon
    },
    {
        path: 'salesReport',
        name: 'Informe de ventas',
        element: SalesReportScreen,
        icon: QueryStatsIcon
    },
    {
        path: 'customers',
        name: 'Clientes',
        element: ListCustomersScreen,
        icon: PeopleIcon
    },
    {
        path: 'inventory',
        name: 'Inventario',
        element: ListBranchOfficeInventoryScreen,
        icon: CircleIcon
    },
    {
        path: 'inventory/pos',
        name: 'Punto de Venta de Inventario',
        element: InventoryPOS
    },
    {
        path: 'inventory/inventoryOrderDetails',
        name: 'Detalles del pedido',
        element: InventoryPOS
    },
    {
        path: 'tablesKiosks',
        name: 'Mesas y Kioskos',
        element: ListTablesKiosksScreen,
        icon: DinnerDining
    }
];
export default collaboratorRoutes;